<template>
  <AuthConsoleCard>
    <AuthConsoleStatus label="Signing you out" />
    <div class="con-foot">© {{ new Date().getFullYear() }} KHK Games. All rights reserved.</div>
  </AuthConsoleCard>
</template>

<script setup>
import { onMounted } from 'vue';
import { useAuth } from '@okta/okta-vue';
import authService from '@/services/AuthService';
import AuthConsoleCard from '@/components/auth/AuthConsoleCard.vue';
import AuthConsoleStatus from '@/components/auth/AuthConsoleStatus.vue';

const $auth = useAuth();

onMounted(async () => {
  // Clear local tokens first so the nav guard won't redirect us back
  await authService.logout();

  try {
    // Revoke tokens and clear Okta SDK state without hitting sessions/me (CORS).
    // On success Okta redirects away; the UI may not repaint before unload.
    await $auth.signOut({ revokeAccessToken: true, revokeRefreshToken: true, clearTokensBeforeRedirect: true });
  } catch (error) {
    console.error('Okta signout error:', error);
    // If Okta signout fails, redirect manually; tokens are already cleared
    window.location.href = '/login';
  }
});
</script>
